module.exports = __webpack_public_path__ + "85f760200732454dcab9d1ba852883ad.png";